import { render, staticRenderFns } from "./EditEmergencyNumberPage.vue?vue&type=template&id=bb95a5e6&"
import script from "./EditEmergencyNumberPage.vue?vue&type=script&lang=js&"
export * from "./EditEmergencyNumberPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports